module.exports = __webpack_public_path__ + "static/media/sitecore.91dde4b3.png";